module.exports = __webpack_public_path__ + "static/media/demoprofile.94ff4972.jpeg";